module.exports = __webpack_public_path__ + "media/icons/balance-scale-left-8eb16737b1513f290da3d5321eba907c.svg";